// document.addEventListener("DOMContentLoaded", () => {
//   setTimeout(() => {
//     const vatInput = document.querySelector("#vat-validation");
//     const submitBtn = document.querySelector('.bss-b2b-rf-submit-button input[type="submit"]');
//     let timer;

//     const disableBtn = () => {
//       submitBtn.disabled = true;
//       submitBtn.style.opacity = "0.5";
//       submitBtn.style.cursor = "not-allowed";
//     };

//     const enableBtn = () => {
//       submitBtn.disabled = false;
//       submitBtn.style.opacity = "1";
//       submitBtn.style.cursor = "pointer";
//     };

//     const startCountdown = () => {
//       if (timer) clearTimeout(timer);
//       timer = setTimeout(() => {
//         enableBtn();
//       }, 2000);
//     };

//     if (vatInput && submitBtn) {
//       // Khi gõ hoặc chọn suggest → disable ngay lập tức
//       vatInput.addEventListener("input", () => {
//         if (vatInput.value.trim() !== "") {
//           disableBtn();
//         } else {
//           enableBtn();
//         }
//       });

//       // Khi người dùng rời khỏi input (blur) hoặc chọn suggest (change) → bắt đầu đếm 3 s
//       vatInput.addEventListener("blur", () => {
//         if (vatInput.value.trim() !== "") startCountdown();
//       });

//       vatInput.addEventListener("change", () => {
//         if (vatInput.value.trim() !== "") startCountdown();
//       });

//       // Dán trực tiếp → disable ngay và sẽ chỉ bật sau khi blur
//       vatInput.addEventListener("paste", () => {
//         if (vatInput.value.trim() !== "") disableBtn();
//       });
//     }
//   }, 2000);
// });

let counter = 0;
let selector = "#accepts-marketing"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);

        const subscribeCheckbox = document.querySelector('#accepts-marketing');
        if (subscribeCheckbox) {
            subscribeCheckbox.checked = true;

            subscribeCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 